import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    horseInfoDesktop: {
      transition: "transform .5s !important",
      "& .MuiDrawer-paper": {
        width: "30%",
        position: "absolute",
        transition: "transform .5s !important",
        overflowY: "clip",
        [theme.breakpoints.down(Breakpoints.MD_960)]: {
          width: "348px"
        },
        [theme.breakpoints.down(Breakpoints.SX_720)]: {
          width: "300px"
        }
      },
      "& .MuiDrawer-paperAnchorDockedRight": {
        borderLeftColor: primary.light
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        display: "none"
      }
    },
    horseInfoMobileTitle: {
      borderBottom: `1px solid ${primary.light}`,
      padding: "0 16px",
      "& .MuiTypography-root": {
        height: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }
    },
    closeHorseInfoMobileIcon: {
      width: 30,
      height: 30,
      color: theme.palette.text.primary
    },
    titleText: {
      fontSize: 18
    },
    horseInfoMobileContent: {
      padding: 0
    },
    emptyBlock: {
      width: 36
    }
  };
});
